;(function () {
  angular
    .module('contrast.wizard.steps')
    .controller('csWizardStepsCtrl', [csWizardStepsCtrl])

  function csWizardStepsCtrl() {
    var vm = this

    var elem

    vm.activate = activate

    vm.x = 0
    vm.y = 18

    function activate(params) {
      vm.total = params.total
      vm.current = params.current
      vm.width = params.width
      elem = params.elem

      var svg = elem.find('svg')
      svg.css({ width: vm.width + 'px' })

      vm.margin = 17

      vm.startX = vm.margin
      vm.endX = vm.width - vm.margin

      vm.lineStartX = vm.startX
      vm.lineEndX = vm.endX

      vm.xInc = calculateXInc()

      vm.configs = buildConfigs()
    }

    function calculateXInc() {
      var width = vm.endX - vm.startX
      return width / (vm.total - 1)
    }

    function buildConfigs() {
      var configs = []
      var config
      var x = vm.startX
      for (var i = 0, len = vm.total; i < len; i++) {
        config = {
          index: i,
          x: x,
          y: vm.y,
          checked: i <= vm.current - 1,
          active: i == vm.current - 1
        }
        configs.push(config)
        x += vm.xInc
      }
      return configs
    }
  }
})()
